export const routes = {
	adminPanel: {
		acquiredAssetProfile: 'manage-acquired-assets/asset-profile/:id',
		alarmHistory: '/alarm-history',
		alarmManagement: '/alarm-management',
		alarms: '/alarms',
		assetHistory: 'assets/asset-profile/:id/history',
		assetHistoryProfile: 'assets/asset-profile/:id/history/:historyId',
		assetProfile: 'assets/asset-profile/:id',
		assetTypes: '/manage-assets-types',
		assets: '/assets',
		assetsDashboard: '/assets-dashboard',
		assignApprovalUnits: '/assign-approve-units',
		downloadHistory: '/download-history',
		errors: '/errors',
		incomingRequestCardAssetProfile: 'incoming-requests/:id/asset-profile/:id',
		incomingRequestPath: '/incoming-requests/:id',
		incomingRequestsPath: '/incoming-requests',
		index: '/admin-panel',
		kpiAiAnalytics: '/kpi-ai-analytics',
		kpiDashboard: '/kpi-dashboard',
		kpiNotifications: '/kpi-notifications',
		manageAcquiredAssets: '/manage-acquired-assets',
		manageAllSites: '/manage-all-site',
		manageApproveUnits: '/manage-approve-units',
		manageCrowdCells: '/manage-crowd-cells',
		managePlatformBranding: '/manage-platform-branding',
		manageSite: '/manage-site',
		middlewareSMO: '/middleware-smo',
		networkElements: '/manage-network-elements',
		organisationProfile: 'organisations/organisation-profile/:id',
		organisationSettings: '/organisation-settings',
		organisations: '/organisations',
		outgoingRequestCardAssetProfile: 'outgoing-requests/:id/asset-profile/:id',
		outgoingRequestPath: '/outgoing-requests/:id',
		outgoingRequestsPath: '/outgoing-requests',
		portalProjectProfile: 'portal-projects/project-profile/:id',
		portalProjects: '/portal-projects',
		requestListPath: '/request-list',
		requestReservationCard: '/requests/reservation/:id',
		ruStatusDashboard: '/ru-status-dashboard',
		sectorsSettings: '/sectors-settings',
		siteProfile: 'manage-site/site-profile/:id',
		thresholdManagementAccessPath: '/threshold',
		userHistory: '/user-history',
		users: '/users',
		vesEvents: '/ves-events',
	},
	map: {
		index: '/map',
	},
	settings: {
		index: '/settings/:id',
	},
	cmModule: {
		index: '/configuration-management',
		configurationComparison: '/configuration-comparison',
		consistencyCheck: '/consistency-check',
		consistencyCheckHistory: '/consistency-check/:id',
		historyCheck: '/history-check',
		networkElementConfigurations: '/network-element-configurations',
		changeMonitoring: '/network-element-configurations/change-monitoring/:id',
		dataSources: '/data-sources',
		configurationDataModelManagement: '/configuration-data-model-management',
		configurationTemplates: '/configuration-templates',
		operationRules: '/operation-rules',
		ruConfiguration: '/ru-configuration',
	},
	userProfile: {
		index: '/user-profile',
	},
	reports: {
		index: '/api-docs',
	},
};
